import { render, staticRenderFns } from "./BeautyTokenGuidePopup.vue?vue&type=template&id=64235b18&scoped=true&"
import script from "./BeautyTokenGuidePopup.vue?vue&type=script&lang=js&"
export * from "./BeautyTokenGuidePopup.vue?vue&type=script&lang=js&"
import style0 from "./BeautyTokenGuidePopup.vue?vue&type=style&index=0&id=64235b18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64235b18",
  null
  
)

export default component.exports